import React from "react";
import PropagateLoader from "react-spinners/PropagateLoader"; // Import the spinner
import { MoonLoader } from "react-spinners";
import "./spinner.css"; // Optional: Styling for the spinner container

const Spinner = () => {
  return (
    <div className="spinner-container">
      <MoonLoader color="#144A8C" size={60} aria-label="Loading Spinner" />{" "}
      {/* Customize color and size */}
    </div>
  );
};

export default Spinner;
